import dagre from "@dagrejs/dagre";
import type { Edge, Node } from "@xyflow/react";
import type { PrepFlowNodeData } from "./graphAdapter";

const NODE_WIDTH = 200;
const NODE_HEIGHT = 80;

export function autoLayoutNodes(nodes: Node<PrepFlowNodeData>[], edges: Edge[]): Node<PrepFlowNodeData>[] {
  if (nodes.length === 0) {
    return nodes;
  }
  const g = new dagre.graphlib.Graph();
  g.setDefaultEdgeLabel(() => ({}));
  g.setGraph({ rankdir: "LR", nodesep: 60, ranksep: 90 });
  nodes.forEach((n) => g.setNode(n.id, { width: NODE_WIDTH, height: NODE_HEIGHT }));
  edges.forEach((e) => {
    if (e.source && e.target) {
      g.setEdge(e.source, e.target);
    }
  });
  dagre.layout(g);
  return nodes.map((n) => {
    const pos = g.node(n.id);
    if (!pos) {
      return n;
    }
    return {
      ...n,
      position: { x: pos.x - NODE_WIDTH / 2, y: pos.y - NODE_HEIGHT / 2 },
    };
  });
}
